module.exports = "/_next/static/videos/soccer-3-8fad0c696feae9691d0393ebcd8c351e.webm";